<template>
  <div class="TableDateDownSelect" :class="getStyle()">
    <div class="dis-block">
      <el-config-provider v-if="pickerShow == 'daterange'" :locale="locale">
        <el-date-picker
          type="daterange"
          class="drop-down-select"
          v-model="tableDateTime.Time"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleSelect"
          size="mini"
        >
        </el-date-picker>
      </el-config-provider>
      <el-config-provider v-if="pickerShow == 'year'" :locale="locale">
        <el-date-picker
          type="year"
          class="drop-down-year"
          v-model="tableDateTime.Time[0]"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleSelect"
          size="mini"
        >
        </el-date-picker>
      </el-config-provider>
      <div class="drop-down-data" v-if="pickerShow == 'date'">
        <el-config-provider :locale="locale">
          <el-date-picker
            type="date"
            popper-class="data-picker"
            v-model="tableDateTime.Time[1]"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handleSelect"
            size="mini"
          >
          </el-date-picker>
        </el-config-provider>
      </div>
    </div>
  </div>
</template>
<script>
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import { getNowTime } from '../publicmethods_js/publicmethods.js';
import moment from 'moment'; // 处理时间插件
import { mapState } from 'vuex';
export default {
  name: 'TableDateDownSelect',
  props: {
    tabselectData: Array,
    selectApi: String,
    pickerType: String,
  },
  data() {
    return {
      locale: zhCn,
      // dataType: 'daterange',
      booDecideTitle: false,
      tableDateTime: {
        Time: [],
        tab: '',
      },
      pickerShow: 'daterange',
      dateAfterHandle: [''],
    };
  },
  computed: {
    ...mapState({
      componentName: state => state.ProjectInfo.CurrentScene.Charts,
    }),
  },
  watch: {
    componentName: {
      handler() {},
      immediate: true,
    },
  },
  mounted() {
    let nowTime = getNowTime(true);
    let startTime = nowTime.slice(0, 8) + '01';
    let motTime = getNowTime('motTime');

    if (this.pickerType) {
      this.pickerShow = this.pickerType[0];
    }

    if (this.selectApi.currenEntry === 'staticData') {
      // 判断未连接api数据
      this.tableDateTime.Time = [startTime, nowTime];
    } else if (this.tabselectData[0] == 'timDat') {
      this.tableDateTime.Time = [motTime, nowTime];
      this.tableDateTime.tab = this.tabselectData[0];
      this.tableDateTime.key = this.tabselectData[1];
    } else {
      this.tableDateTime.Time = [startTime, nowTime];
      this.tableDateTime.tab = this.tabselectData[0];
    }

    this.handleSelect(this.tableDateTime);
  },
  methods: {
    getStyle() {
      let style = {};
      switch (this.componentName) {
        case 'V1Style':
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style['V5Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    // 格式化处理时间
    dealTime(date) {
      let format = '';
      switch (date) {
        case '3':
          format = 'YYYY';
          break;
        case '2':
          format = 'YYYY-MM';
          break;
        case '1':
          format = 'YYYY-MM-DD';
          break;
        default:
          format = 'YYYY-MM-DD';
          break;
      }
      return moment(date).format(format);
    },
    handleSelect() {
      this.dateAfterHandle = [];
      if (this.tableDateTime.Time instanceof Array) {
        this.tableDateTime.Time.forEach(item => {
          this.dateAfterHandle.push(this.dealTime(item));
        });
      }
      this.dateAfterHandle.unshift(this.tableDateTime.tab);
      if (this.tableDateTime.key) {
        this.dateAfterHandle.push(this.tableDateTime.key);
      }
      console.log(this.dateAfterHandle, 'tableDateTime.');
      this.$emit('tabSelectChange', this.dateAfterHandle);
    },
  },
};
</script>

<style lang="scss" scoped>
.TableDateDownSelect {
  position: relative;
  z-index: 999;
}

:deep().drop-down-select.el-date-editor--daterange.el-input__inner {
  background-color: #0000;
  border: 1px solid #148cdb;
  width: 204px;
}

:deep().drop-down-select.el-range-editor.el-input__inner {
  display: inline-flex;
  align-items: center;
  padding: 3px 4px;
}
:deep().drop-down-select.el-date-editor .el-range-separator {
  padding: 0;
  margin: 0 4px;
  color: #03b8ca;
  text-align: center;
  font-size: 11px;
}
:deep().drop-down-select.el-date-editor .el-range-input {
  background-color: #0000;
  color: #ffffff;
  width: 36%;
}
:deep().drop-down-select.el-date-editor .el-range__icon {
  color: #03b8ca;
}
:deep().drop-down-select.el-range-editor--small .el-range-input {
  font-size: 10px;
}
:deep().drop-down-year {
  .el-input__inner {
    background-color: #ffffff00;
    color: #ffffff;
    border: 1px solid #148cdb;
  }
  .el-input__prefix {
    color: #03b8ca;
  }
}
.drop-down-data ::v-deep .el-input__prefix {
  left: 74px;
}

.drop-down-data ::v-deep .el-input__inner {
  background: none !important;
  border: 1px solid #148cdb;
  color: #fff;
  width: 150px;
  position: relative;
  right: -70px;
}

.V3Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #148cdb;
    color: #03b8ca;
    font-size: 12px;
    background: linear-gradient(to top, #0c2b67, #031639, #0c2b67);
  }
  :deep().drop-down-date .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #148cdb;
    color: #03b8ca;
    font-size: 12px;
    background: linear-gradient(to top, #0c2b67, #031639, #0c2b67);
  }

  :deep().el-icon-arrow-up:before {
    color: #1597e6;
  }
  :deep().drop-down-select.el-date-editor--daterange.el-input__inner {
    background-color: #0000;
    border: 1px solid #148cdb;
    width: 200px;
  }
  .drop-down-data ::v-deep .el-input__prefix {
    left: 74px;
  }

  .drop-down-data ::v-deep .el-input__inner {
    background: none !important;
    border: 1px solid #148cdb;
    color: #fff;
    width: 150px;
    position: relative;
    right: -70px;
  }
}

.V4Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #8d77d8;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #8d77d8;
  }
}

.V5Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #03a252;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #03a252;
  }
}
</style>
